<template>
  <el-dialog
      v-el-drag-dialog
      :close-on-click-modal="false"
      class="WorkOrderIssuedEdit"
      :title="disabled ? '详情' : model.pkId > 0 ? '编辑' : '新建'"
      :visible.sync="visible"
      top="2vh"
      width="1000px"
      @close="$reset('form')">
    <el-form
        ref="form"
        v-loading="contentLoading"
        :model="model"
        :disabled="disabled"
        label-width="80px"
        :rules="ruleValidate"
        class="form">
      <div class="editTitle">基本信息</div>
      <el-row>
        <el-col v-if="model.pkId > 0" :span="12">
          <el-form-item label="派工单号">
            <el-input v-model="model.billNo" disabled/>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="工单编号">
            <el-input v-model="model.productionOrderNo" disabled/>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="物料名称">
            <el-input v-model="model.materialName" disabled/>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="剩余数量">
            <el-input v-model="model.leftQuantity" disabled/>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="工作中心" prop="workCenterName">
            <el-input v-model="model.workCenterName" placeholder="请选择工作中心" readonly>
              <el-button slot="append" @click="$refs.selectWorkCenter.open()">选择</el-button>
            </el-input>
            <work-center-select ref="selectWorkCenter" @select="onSelectWorkCenter"/>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="派单数量" prop="quantity">
            <el-input v-model="model.quantity" placeholder="请输入派工单数量"/>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="工艺路线" prop="routeId">
            <el-select v-model="model.routeId" placeholder="请选择工艺路线" disabled>
              <el-option v-for="item in routeList" :key="item.pkid" :label="item.routingName" :value="item.pkid"/>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="开工时间" prop="planStartTime">
            <el-date-picker
                v-model="model.planStartTime"
                type="date"
                style="width: 100%"
                placeholder="选择开工时间"
                value-format="yyyy-MM-dd"/>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="完工时间" prop="planFinishTime">
            <el-date-picker
                v-model="model.planFinishTime"
                style="width: 100%"
                type="date"
                placeholder="选择完工时间"
                value-format="yyyy-MM-dd"/>
          </el-form-item>
        </el-col>
      </el-row>
      <div class="editTitle">生产BOM</div>
      <el-table
          :data="model.bomList"
          border
          row-key="pkid"
          height="160px">
        <el-table-column prop="materialNo" align="left" label="物料编号" width="150"/>
        <el-table-column prop="materialName" align="left" label="物料名称"/>
        <el-table-column prop="unit" align="center" label="单位" width="80"/>
        <el-table-column prop="quantity" align="center" label="数量" width="80"/>
      </el-table>
      <div class="editTitle" style="margin-top: 5px">产品工艺</div>
      <material-route-info
          :action-show="disabled"
          :tree-data="treeData"
          :origin-table-data="originTableData"
          :route-id="model.routeId + ''"
          @updateSuccess="getFinalTableData"/>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="visible = false">取 消</el-button>
      <el-button v-if="!disabled" type="primary" :loading="submitLoading" @click="handleOk">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
  import WorkCenterSelect from "@/views/information/WorkCenter/WorkCenterSelect";
  import MaterialRouteInfo from "./MaterialRouteInfo";
  import moment from "moment";

  export default {
    components: {
      WorkCenterSelect,
      MaterialRouteInfo,
    },

    data() {
      return {
        disabled: false,
        initBomList: [],
        treeData: [],
        originTableData: [],
        routeList: [],
        visible: false,
        contentLoading: false,
        productOrderInfo: {},
        model: {
          pkId: 0,
          bomList: [],
          billNo: "",
          productionOrderNo: "",
          materialName: "",
          leftQuantity: "",
          workCenterName: "",
          workCenterId: "",
          quantity: "",
          planStartTime: "",
          planFinishTime: "",
          routeId: "",
        },
        // 表单校验
        ruleValidate: {
          workCenterName: [{required: true, message: "请选择工作中心", trigger: "change"}],
          planStartTime: [{required: true, message: "请选择计划开始日期", trigger: "blur"}],
          planFinishTime: [{required: true, message: "请选择计划完工日期", trigger: "blur"}],
          routeId: [{required: true, message: "请选择工艺路线", trigger: "blur"}],
          quantity: [
            {required: true, message: "请输入派工单数量", trigger: "blur"},
            {pattern: /^[1-9]\d*$/, message: "请输入有效的数值"},
          ],
        },
        submitLoading: false,
      };
    },

    watch: {
      "model.quantity": {
        handler(val) {
          if (val) {
            this.getBatchBomInfo();
          }
        },
      },
    },

    methods: {
      // 模态框OPEN
      open(id, disabled, order) {
        if (disabled) {
          this.disabled = true;
        }
        this.model.pkId = id;
        if (id > 0) {
          this.getBatchInfo(id);
        } else {
          this.productOrderInfo = order;
          this.model.productionOrderNo = this.productOrderInfo.productionOrderNo;
          this.model.materialId = this.productOrderInfo.materialId;
          this.model.materialName = this.productOrderInfo.materialName;
          this.model.routeId = this.productOrderInfo.routeId;
          this.model.routingName = this.productOrderInfo.routingName;
          this.model.workCenterId = this.productOrderInfo.workCenterId;
          this.model.workCenterName = this.productOrderInfo.workCenterName;
          this.treeData = this.productOrderInfo.treeData;
          this.originTableData = this.productOrderInfo.routeList;

          this.model.planStartTime = moment(new Date()).add(2, "days").format("YYYY-MM-DD");
          console.log(this.productOrderInfo);
          if (this.productOrderInfo.materialTypeNo == "03.03") {
            this.model.planStartTime = moment(new Date()).add(1, "days").format("YYYY-MM-DD");
          }

          // this.model.planStartTime = this.productOrderInfo.planStartTime;
          this.model.planFinishTime = this.productOrderInfo.planFinishTime;
          // if (this.productOrderInfo.deliveryDate) {
          //   this.model.planFinishTime = this.productOrderInfo.deliveryDate;
          // }
          // 根据生产订单编号好获取派工单编号、剩余数量
          this.$http.get("basic", `taskDispatchBills/batchinfo?prodOrderNo=${this.model.productionOrderNo}`).then((resp) => {
            if (resp.success) {
              // this.model.billNo = resp.data.nextBatchNo;
              this.model.leftQuantity = resp.data.leftQuantity;
              this.model.quantity = resp.data.leftQuantity;
              this.getRouteListByMetrialId();
            }
          });
          this.visible = true;
        }
      },

      // 选择工作中心
      onSelectWorkCenter(row) {
        this.model.workCenterName = row.workCenterName;
        this.model.workCenterId = row.pkId;
      },

      // 根据物料ID查询工艺路线
      getRouteListByMetrialId() {
        this.$http.get("basic", `rtRouteMaterials/getMaterialRouteList?materialId=${this.model.materialId}`).then((resp) => {
          if (resp.success) {
            this.routeList = resp.data;
          }
        });
      },

      //根据pkid查询子表信息(编辑)
      getBatchInfo(id) {
        this.contentLoading = true;
        this.$http
            .get("basic", `taskDispatchBills/${id}`)
            .then((resp) => {
              if (resp.success) {
                this.model.billNo = resp.data.billNo;
                this.model.productionOrderNo = resp.data.productionOrderNo;
                this.model.materialId = resp.data.materialId;
                this.model.materialName = resp.data.materialName;
                this.model.planStartTime = resp.data.planStartTime;
                this.model.planFinishTime = resp.data.planFinishTime;
                this.model.quantity = resp.data.quantity;
                this.model.routeId = resp.data.routeId;
                this.model.workCenterName = resp.data.workCenterName;
                this.model.workCenterId = resp.data.workCenterId;
                this.model.leftQuantity = resp.data.leftQuantity + resp.data.quantity;
                this.treeData = resp.data.treeData;
                this.originTableData = resp.data.routeProcessList;
                this.getRouteListByMetrialId();
                this.visible = true;
              }
              this.contentLoading = false;
            })
            .catch(() => {
              this.contentLoading = false;
            });
      },

      // 将对象数组根据processIndex进行分组
      getGroupByProcessIndex(arr) {
        let map = {};
        let myArr = [];
        for (let i = 0; i < arr.length; i++) {
          if (!map[arr[i].processIndex]) {
            myArr.push({
              processIndex: arr[i].processIndex,
              data: [arr[i]],
            });
            map[arr[i].processIndex] = arr[i];
          } else {
            for (let j = 0; j < myArr.length; j++) {
              if (arr[i].processIndex === myArr[j].processIndex) {
                myArr[j].data.push(arr[i]);
                break;
              }
            }
          }
        }
        return myArr;
      },

      getFinalTableData(data) {
        this.originTableData = data;
      },

      // 提交
      handleOk() {
        // 表单校验是否通过
        this.$refs.form.validate((valid) => {
          if (valid) {
            if (this.$moment(this.model.planFinishTime).valueOf() < this.$moment(this.model.planStartTime).valueOf()) {
              this.$confirm("请选择有效的时间范围", "错误", {
                type: "error",
                showCancelButton: false,
              });
              return;
            }
            const newArr = this.getGroupByProcessIndex(this.originTableData);
            newArr.forEach((item) => {
              item.data.forEach((i, index) => {
                i.scanIndex = index + 1;
              });
            });
            let finalArr = [];
            newArr.forEach((item) => {
              item.data.forEach((i) => {
                finalArr.push(i);
              });
            });
            this.model.routeProcessList = finalArr;
            this.submitLoading = true;
            this.$http
                .save("basic", "taskDispatchBills", this.model)
                .then((resp) => {
                  if (resp.success) {
                    this.visible = false;
                    if (this.model.pkId) {
                      this.$emit("save-success");
                      this.$message.success("编辑成功");
                    } else {
                      this.$emit("save-success");
                      this.$message.success("添加成功");
                    }
                    this.dialogVisible = false;
                  }
                  this.submitLoading = false;
                })
                .catch(() => {
                  this.submitLoading = false;
                });
          }
        });
      },

      // 输入派工单数量获取派工单BOM信息
      getBatchBomInfo() {
        // 编辑
        if (this.model.pkId) {
          this.$http.get("basic", `taskDispatchBills/getbomlist?prodOrderNo=${this.model.productionOrderNo}&quantity=${this.model.quantity}&prodOrderId=${this.model.pkId}`).then((resp) => {
            if (resp.success) {
              this.model.bomList = resp.data;
            }
          });
        } else {
          // 新建
          this.$http.get("basic", `taskDispatchBills/getbomlist?prodOrderNo=${this.model.productionOrderNo}&quantity=${this.model.quantity}`).then((resp) => {
            if (resp.success) {
              this.model.bomList = resp.data;
            }
          });
        }
      },
    },
  };
</script>
<style>
.WorkOrderIssuedEdit .el-dialog__header {
  position: fixed;
  width: 100%;
  top: 0;
  z-index: 99999;
  box-sizing: border-box;
}

.WorkOrderIssuedEdit .el-dialog__footer {
  position: fixed;
  width: 100%;
  bottom: 0;
  z-index: 99999;
  box-sizing: border-box;
  background-color: #fff;
}

.WorkOrderIssuedEdit .el-dialog {
  margin: 2% auto !important;
  transform: scale3d(1, 1, 1);
  padding-top: 30px;
  padding-bottom: 69px;
  height: 90%;
}

.WorkOrderIssuedEdit .el-divider--horizontal {
  margin: 10px 0;
}

.WorkOrderIssuedEdit .el-dialog .el-dialog__body {
  height: 100%;
  background-color: #fff;
  overflow: scroll;
}

.editTitle {
  border-bottom: 1px solid #ddd;
  margin-bottom: 15px;
  padding-bottom: 10px;
}
</style>
